export enum VideoType {
  NAVIGATION = 'navigation',
  PROCESS_INTRODUCTION = 'process-introduction',
  WHAT_IS = 'what-is',
  TUTORIAL = 'tutorial',
  PURPOSE = 'purpose',
  POWERPOINT = 'powerpoint',
  HOW_TO = 'how-to',
  OTHER = 'other',
  HOW_TO_MANUAL_SCRIPT = 'how-to-manual-script'
}
